// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2d79c050","977":"8d2c4913"}[chunkId] + ".chunk.js";
};